export default {
  "hero.eyebrow": "THE USFANS SPREADSHEET RESOURCE HUB",
  "hero.title": "USFans Spreadsheet — Find, Compare & Research Products Smarter",
  "hero.subtitle": "Explore USFans Spreadsheet resources, product research, seller information, QC guides, shipping information, comparisons and safety tips — all organized in one easy-to-use resource hub.",
  "hero.trust": "Independent Resource • Practical Guides • Regularly Updated",
  "hero.support": "Looking for a faster way to research products? Use our organized resources to discover categories, compare information and make better-informed decisions.",
  "cat.title": "Browse Products by Category",
  "cat.subtitle": "Choose a category below to jump straight to the matching collection on the main USFans store.",
  "cat.dropdownLabel": "Select a category",
  "cat.dropdownPlaceholder": "Choose a category…",
  "about.title": "What Is the USFans Spreadsheet?",
  "about.p1": "The USFans Spreadsheet is a structured way to organize product, seller and related information in one place. Instead of searching through scattered pages, users can research categories, compare information and discover relevant guides more efficiently.",
  "about.p2": "USFansSheet aims to make USFans Spreadsheet research simpler, clearer and more useful for both beginners and experienced users.",
  "about.cta": "Explore the USFans Spreadsheet",
  "value.title": "Everything You Need to Research USFans",
  "value.subtitle": "Practical resources that help you browse, compare and verify before you buy.",
  "value.c1.title": "USFans Spreadsheet",
  "value.c1.text": "Organized product and research resources in one place.",
  "value.c2.title": "Product Research",
  "value.c2.text": "Compare products, categories and available information.",
  "value.c3.title": "QC Guides",
  "value.c3.text": "Understand QC information and what to check.",
  "value.c4.title": "Shipping Guides",
  "value.c4.text": "Learn what affects shipping methods and costs.",
  "value.c5.title": "Reviews & Comparisons",
  "value.c5.text": "Explore USFans research and comparison guides.",
  "value.c6.title": "Safety Resources",
  "value.c6.text": "Learn how to verify information and avoid suspicious links.",
  "article.title": "Featured Guide",
  "article.subtitle": "New to the USFans Spreadsheet? Start with our beginner-friendly guide to smarter product research.",
  "article.button": "Read the Full Guide",
  "article.tag": "Beginner Guide",
  "faq.title": "Frequently Asked Questions",
  "faq.q1": "Is the USFans Spreadsheet free to access?",
  "faq.a1": "The USFansSheet resource hub is free to browse. Product listings and purchases are handled on the main USFans store, so always verify details there before buying.",
  "faq.q2": "How often is the information updated?",
  "faq.a2": "We aim to review and refresh our guides regularly. Because product availability and shipping details can change, always confirm current information on the main store.",
  "faq.q3": "Can I find every product in one place?",
  "faq.a3": "Our category links take you directly to the matching collections on the main USFans store, where you can browse the full, current selection.",
  "faq.q4": "How do I stay safe while shopping?",
  "faq.a4": "Verify links before clicking, check seller and product details, and be cautious with any promotion that looks too good to be true.",
};